import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useSearchParams } from "react-router-dom";
import { registerMetadata } from "@/services/metadataEvent";
import { Container, Link, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "./a-taxa-selic-subiu.scss";
import { abreSimulador } from "@/services/utils";

export default function ATaxaSelecSubiu() {
  const [searchParams] = useSearchParams();
  searchParams.get("__firebase_request_key");

  useEffect(() => {
    const metaData = {};
    metaData.utmSource = searchParams.get("utm_source");
    metaData.utmMedium = searchParams.get("utm_medium");
    metaData.utmCampaign = searchParams.get("utm_campaign");
    metaData.utmId = searchParams.get("utm_id");
    metaData.utmTerm = searchParams.get("utm_term");
    const metadataRegister = {
      ...metaData,
      isMobile: isMobile,
      userAction:
        "VIEW_BLOG_A_TAXA_SELIC_E_O_NOSSO_PARCELAMENTO_CONTINUA_O_MESMO",
      url: window.location.href,
    };

    registerMetadata(metadataRegister, "METADATA_VIEW_SITE_QUITABOLETOS");
  }, [searchParams]);

  return (
    <Container className="sessao-post">
      <Grid
        size={12}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}>
        <Grid container spacing={3} maxWidth="sm" sx={{ py: 3 }}>
          <Grid
            className="logo-blog"
            size={12}
            sx={{
              display: { xs: "none", sm: "flex" },
              justifyContent: "center",
            }}>
            <img
              className="logo-blog-img"
              src="/site/blog/blog_a_taxa_selic_subiu.png"
              alt="logo-blog"
            />
          </Grid>

          <Grid size={12}>
            <Typography variant="h1" sx={{ mt: 2, p: 1 }}>
              A taxa Selic subiu, mas o nosso parcelamento permanece o mesmo:
              Entenda por quê
            </Typography>
          </Grid>

          <Grid size={12}>
            <Typography sx={{ fontSize: 22, fontStyle: "italic" }}>
              Nos últimos meses, a taxa Selic — principal indicador de juros da
              economia brasileira — voltou a subir, impactando diretamente o
              custo do crédito, os financiamentos e até o parcelamento no cartão
              de crédito. Para quem já está no limite do orçamento, qualquer
              aumento nos juros pode ser um grande obstáculo.
            </Typography>
            <Typography sx={{ fontSize: 22, fontStyle: "italic" }}>
              Mas na <span className="quita">Quita Boletos</span>, temos uma boa
              notícia: mesmo com a alta da Selic, o nosso parcelamento continua
              com as mesmas condições. Entenda por que conseguimos manter essa
              estabilidade e como isso pode ajudar você a organizar suas
              finanças.
            </Typography>
          </Grid>

          <Grid container spacing={2} sx={{ mx: 1, mt: 2 }}>
            <Grid size={12}>
              <Typography sx={{ fontSize: 24, fontWeight: "bold", mb: 1 }}>
                O que é a taxa Selic e por que ela afeta o seu bolso?
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography sx={{ fontSize: 20, mb: 2 }}>
                A Selic é a taxa básica de juros da economia brasileira,
                definida pelo Banco Central. Quando ela sobe, os juros cobrados
                por bancos e financeiras também aumentam, tornando mais caro
                pegar empréstimos, financiar compras ou parcelar dívidas no
                cartão de crédito.
              </Typography>
              <Typography sx={{ fontSize: 20, mb: 2 }}>
                Isso significa que, em geral, o consumidor paga mais para
                parcelar boletos, fazer compras parceladas ou até mesmo usar o
                rotativo do cartão.
              </Typography>
            </Grid>

            <Grid size={12}>
              <Typography sx={{ fontSize: 24, fontWeight: "bold", mb: 1 }}>
                Parcelar boleto com cartão de crédito: como funciona?
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography sx={{ fontSize: 20 }}>
                Muitas pessoas buscam alternativas para organizar as finanças e
                evitar a inadimplência. Uma das soluções mais procuradas é o
                parcelamento de boletos com cartão de crédito.
              </Typography>
              <Typography sx={{ fontSize: 20 }}>
                Na prática, vo
                <strong>
                  cê utiliza o limite do seu cartão para pagar contas
                </strong>{" "}
                como aluguel, escola, água, luz ou qualquer outro boleto. O
                valor é dividido em parcelas fixas, que são cobradas na fatura
                do cartão, permitindo que você ganhe fôlego no orçamento mensal.
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography sx={{ fontSize: 24, fontWeight: "bold", mb: 1 }}>
                Pix com cartão de crédito: é possível?
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography sx={{ fontSize: 20 }}>
                Sim, é possível realizar pagamentos via Pix utilizando o limite
                do cartão de crédito. Essa modalidade permite que você faça
                transferências instantâneas mesmo sem saldo na conta, utilizando
                o crédito disponível no cartão.
              </Typography>
              <Typography sx={{ fontSize: 20 }}>
                Essa opção é especialmente útil em situações emergenciais ou
                quando é necessário realizar um pagamento imediato, mas o saldo
                em conta está insuficiente.
              </Typography>
            </Grid>

            <Grid size={12}>
              <Typography sx={{ fontSize: 24, mb: 1 }}>
                Por que a <span className="quita">Quita Boletos</span> mantém as
                mesmas condições de parcelamento?
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography sx={{ fontSize: 20, mb: 1 }}>
                Enquanto muitas instituições financeiras ajustam suas taxas
                conforme a variação da Selic, na{" "}
                <span className="quita">Quita Boletos</span> optamos por manter
                as condições de parcelamento inalteradas. Isso é possível
                porque:
              </Typography>

              <ul className="lista">
                <li>
                  <span className="quita">Foco na estabilidade: </span>
                  Priorizamos oferecer soluções financeiras que proporcionem
                  previsibilidade e tranquilidade aos nossos clientes.
                </li>
                <li>
                  <span className="quita">Compromisso com o cliente: </span>
                  Entendemos que momentos de instabilidade econômica exigem
                  apoio e flexibilidade, não mais obstáculos.
                </li>
              </ul>
            </Grid>
            <Grid size={12}>
              <Typography sx={{ fontSize: 24 }}>
                Como parcelar boletos ou fazer Pix com cartão de crédito na
                Quita Boletos?
              </Typography>
            </Grid>
            <Grid size={12}>
              <ol className="lista">
                <li className="descricao">
                  <span className="quita">Acesse o simulador: </span> Clique{" "}
                  <Link
                    sx={{ cursor: "pointer" }}
                    onClick={() => abreSimulador()}>
                    <strong>aqui</strong>
                  </Link>{" "}
                  ou em <strong>SIMULAR</strong>
                </li>
                <li>
                  <span className="quita">Escolha o número de parcelas:</span>{" "}
                  Selecione a quantidade de parcelas que melhor se adequa ao seu
                  orçamento.
                </li>
                <li>
                  <span className="quita">Simule o pagamento:</span> Informe os
                  dados do boleto ou da transferência via Pix que deseja
                  realizar
                </li>
                <li>
                  <span className="quita">Confirme o pagamento:</span> Utilize o
                  seu <strong>cartão de crédito</strong> para concluir a
                  operação
                </li>
              </ol>

              <Typography sx={{ fontSize: 20, my: 1 }}>
                Pronto! Seu boleto será pago ou a transferência via Pix será
                realizada, e você poderá acompanhar tudo pelo nosso portal.
              </Typography>
              <Typography sx={{ fontSize: 20, mb: 1, fontStyle: "italic" }}>
                Em tempos de juros altos e orçamento apertado, contar com
                soluções financeiras acessíveis e estáveis faz toda a diferença.
                Na <span className="quita">Quita Boletos</span>, nosso
                compromisso é oferecer alternativas que realmente caibam no seu
                bolso, independentemente das oscilações do mercado.
              </Typography>
              <Typography sx={{ fontSize: 20, mb: 1 }}>
                Seja para parcelar boletos ou realizar pagamentos via Pix com
                cartão de crédito, estamos aqui para ajudar você a manter suas
                contas em dia e sua tranquilidade financeira.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
